/**
 * `localePath` pour un lien écrit en TEXTE : chemin (« /a/b?x=1#c »), URL
 * externe (renvoyée telle quelle) ou nom de page.
 *
 * @nuxtjs/i18n 10 n'accepte plus les chemins en texte dans son TYPAGE (un nom
 * de page ou un objet `{ path }` seulement) mais les résout toujours à
 * l'exécution. On reproduit exactement son découpage
 * (`normalizeRawLocation` : URL externe inchangée, « /… » découpé en
 * chemin + query + hash, sinon nom de page) : le lien produit est identique.
 * Pour un chemin écrit en dur, préférer `localePath({ path: "/…" })`.
 */
import { hasProtocol, parsePath, parseQuery } from "ufo";
import { estPageTraduite } from "../../i18n/pagesTraduites";

type LocalePath = ReturnType<typeof useLocalePath>;

export function lienLocalAvec(localePath: LocalePath, lien: string): string {
  if (hasProtocol(lien, { acceptRelative: true })) return lien;
  if (!lien.startsWith("/")) return localePath(lien as Parameters<LocalePath>[0]);
  const { pathname, search, hash } = parsePath(lien);
  // Page en français seulement (le blog, i18n/pagesTraduites.ts) : elle n'a
  // aucune route traduite et localePath rendrait une adresse VIDE (lien sans
  // href, carte non cliquable). Le chemin français reste tel quel.
  if (!estPageTraduite(pathname.slice(1))) return lien;
  return localePath({ path: pathname, query: parseQuery(search), hash });
}

export function useLienLocal(): (lien: string) => string {
  const localePath = useLocalePath();
  return (lien: string) => lienLocalAvec(localePath, lien);
}
